<template>
  <div>
    <div
      v-bind="$attrs"
      class="bg-gray-50 animate-pulse rounded-lg"
      :style="{ height: `${height}px` }"
    />
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
});

withDefaults(
  defineProps<{
    height?: number;
  }>(),
  {
    height: 100,
  },
);
</script>
